
import { useSelector } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import AIResponseActions from "./AIResponseActions";

const TextCard = ({ 
   data,
   index,
   aiResponse,
   getAIResponse,
   readPersonalChats,
   isAITyping,
   handleSubmit,
   toggleAiBotMode,
   isAiBotMode,
}) => {
	const LoginData = useSelector((state) => state.user.LoginData);

	const sender =
		data.messageType !== 'ai/Response' && data?.senderId === LoginData?.uuid;

	const className = sender
		? 'bg-dark text-white px-3 py-2 chat-item text-break fold-Text-small message-content'
		: 'sendertextArea text-black bg-opacity-10 px-3 py-2 chat-item text-break fold-Text-small message-content';

	const style = { width: 'fit-content' };
	const elementId = `mesasage-Input-area${index}`;

	if (data.messageType === 'ai/Response' && data?.body) {
		return (
			<div
  style={{ display: "flex", flexDirection: "column", position: "relative" }}
  className={`${className} mb-3 ai-message-container`}  
>
  <ReactMarkdown>{data.body}</ReactMarkdown>

  {aiResponse && isAiBotMode?.enable && (
    <AIResponseActions
      data={data}
      readPersonalChats={readPersonalChats}
      isAITyping={isAITyping}
      getAIResponse={getAIResponse}
      handleSubmit={handleSubmit}
      toggleAiBotMode={toggleAiBotMode}
      isAiBotMode={isAiBotMode}
      LoginData={LoginData}
    />
  )}
</div>
		);
	}

	// Strip HTML tags to check if there's actual text content
	const hasTextContent = typeof data?.body === 'string' && data.body.replace(/<[^>]*>/g, '').trim();

	if (hasTextContent) {
		return ( <div style={style} className={className} id={elementId} dangerouslySetInnerHTML={{ __html: data.body }} /> );
	}

	return null;
};

export default TextCard;
